module.exports = __webpack_public_path__ + "static/media/AdobeStock_247963248.729dc83a.jpg";